import {ApiCreateRuleActionRequestDto, ApiRuleActionResponseDto, RuleActionTargetType} from '@birco/rainmesh-api';
import {RuleActionFormModel} from '../models/rule-action-form-model.interface';
import {RuleActionViewModel} from '../models/rule-action-view-model.interface';

export const RuleActionConverter = {
  toRequestDtoList: (formDtoList: RuleActionFormModel[]): ApiCreateRuleActionRequestDto[] => {
    return formDtoList.map((it) => {
      const dto = {
        id: it.id,
        targetType: !!it.deviceId ? RuleActionTargetType.DEVICE : RuleActionTargetType.DEVICE_GROUP,
        deviceId: it.deviceId,
        deviceGroupId: it.deviceGroupId,
        duration: it.duration,
        value: true,
      };

      // API will return 400 if we send an (even empty) id field in the ApiCreateRuleActionRequestDto. Only Updates allow this.
      if (!it.id) {
        delete dto.id;
      }

      return dto;
    });
  },

  toFormModelList: (responseDtoList: ApiRuleActionResponseDto[]): RuleActionFormModel[] => {
    return responseDtoList.map((it) => RuleActionConverter.toFormModel(it));
  },

  toFormModel: (responseDto: ApiRuleActionResponseDto): RuleActionFormModel => {
    return {
      id: responseDto.id,
      deviceId: responseDto.device?.id,
      deviceGroupId: responseDto.deviceGroup?.id,
      duration: responseDto.duration!!,
    }
  },

  toViewModelList: (responseDtoList: ApiRuleActionResponseDto[]): RuleActionViewModel[] => {
    return responseDtoList.map((it) => RuleActionConverter.toViewModel(it));
  },

  toViewModel: (responseDto: ApiRuleActionResponseDto): RuleActionViewModel => {
    return {
      id: responseDto.id,
      value: responseDto.value,
      device: responseDto.device ? {
        ...responseDto.device
      } : undefined,
      deviceGroup: responseDto.deviceGroup ? {
        ...responseDto.deviceGroup
      } : undefined,
      duration: responseDto.duration!!,
    }
  },
}
